import * as ambassadorWixBillingV1TaxRegion from './billing-v1-tax-region-tax-regions.http.js';
import * as ambassadorWixBillingV1TaxRegionTypes from './billing-v1-tax-region-tax-regions.types.js';
import * as ambassadorWixBillingV1TaxRegionUniversalTypes from './billing-v1-tax-region-tax-regions.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createTaxRegion(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBillingV1TaxRegionUniversalTypes.CreateTaxRegionRequest,
  ambassadorWixBillingV1TaxRegionTypes.CreateTaxRegionRequest,
  ambassadorWixBillingV1TaxRegionUniversalTypes.CreateTaxRegionResponse,
  ambassadorWixBillingV1TaxRegionTypes.CreateTaxRegionResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBillingV1TaxRegion.createTaxRegion(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/tax-regions',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getTaxRegion(): __PublicMethodMetaInfo<
  'GET',
  { taxRegionId: string },
  ambassadorWixBillingV1TaxRegionUniversalTypes.GetTaxRegionRequest,
  ambassadorWixBillingV1TaxRegionTypes.GetTaxRegionRequest,
  ambassadorWixBillingV1TaxRegionUniversalTypes.GetTaxRegionResponse,
  ambassadorWixBillingV1TaxRegionTypes.GetTaxRegionResponse
> {
  const payload = { taxRegionId: ':taxRegionId' } as any;

  const getRequestOptions =
    ambassadorWixBillingV1TaxRegion.getTaxRegion(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/tax-regions/{taxRegionId}',
    pathParams: { taxRegionId: 'taxRegionId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateTaxRegion(): __PublicMethodMetaInfo<
  'PATCH',
  { taxRegionId: string },
  ambassadorWixBillingV1TaxRegionUniversalTypes.UpdateTaxRegionRequest,
  ambassadorWixBillingV1TaxRegionTypes.UpdateTaxRegionRequest,
  ambassadorWixBillingV1TaxRegionUniversalTypes.UpdateTaxRegionResponse,
  ambassadorWixBillingV1TaxRegionTypes.UpdateTaxRegionResponse
> {
  const payload = { taxRegion: { id: ':taxRegionId' } } as any;

  const getRequestOptions =
    ambassadorWixBillingV1TaxRegion.updateTaxRegion(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/tax-regions/{taxRegion.id}',
    pathParams: { taxRegionId: 'taxRegionId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteTaxRegion(): __PublicMethodMetaInfo<
  'DELETE',
  { taxRegionId: string },
  ambassadorWixBillingV1TaxRegionUniversalTypes.DeleteTaxRegionRequest,
  ambassadorWixBillingV1TaxRegionTypes.DeleteTaxRegionRequest,
  ambassadorWixBillingV1TaxRegionUniversalTypes.DeleteTaxRegionResponse,
  ambassadorWixBillingV1TaxRegionTypes.DeleteTaxRegionResponse
> {
  const payload = { taxRegionId: ':taxRegionId' } as any;

  const getRequestOptions =
    ambassadorWixBillingV1TaxRegion.deleteTaxRegion(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/tax-regions/{taxRegionId}',
    pathParams: { taxRegionId: 'taxRegionId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryTaxRegions(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBillingV1TaxRegionUniversalTypes.QueryTaxRegionsRequest,
  ambassadorWixBillingV1TaxRegionTypes.QueryTaxRegionsRequest,
  ambassadorWixBillingV1TaxRegionUniversalTypes.QueryTaxRegionsResponse,
  ambassadorWixBillingV1TaxRegionTypes.QueryTaxRegionsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBillingV1TaxRegion.queryTaxRegions(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/tax-regions/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  TaxRegion as TaxRegionOriginal,
  CreateTaxRegionRequest as CreateTaxRegionRequestOriginal,
  CreateTaxRegionResponse as CreateTaxRegionResponseOriginal,
  ConflictErrorDetails as ConflictErrorDetailsOriginal,
  BulkCreateTaxRegionRequest as BulkCreateTaxRegionRequestOriginal,
  BulkCreateTaxRegionResponse as BulkCreateTaxRegionResponseOriginal,
  BulkCreateTaxRegionResult as BulkCreateTaxRegionResultOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  GetTaxRegionRequest as GetTaxRegionRequestOriginal,
  GetTaxRegionResponse as GetTaxRegionResponseOriginal,
  UpdateTaxRegionRequest as UpdateTaxRegionRequestOriginal,
  UpdateTaxRegionResponse as UpdateTaxRegionResponseOriginal,
  DeleteTaxRegionRequest as DeleteTaxRegionRequestOriginal,
  DeleteTaxRegionResponse as DeleteTaxRegionResponseOriginal,
  QueryTaxRegionsRequest as QueryTaxRegionsRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryTaxRegionsResponse as QueryTaxRegionsResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  CreateOrGetTaxRegionWithoutValidationRequest as CreateOrGetTaxRegionWithoutValidationRequestOriginal,
  CreateOrGetTaxRegionWithoutValidationResponse as CreateOrGetTaxRegionWithoutValidationResponseOriginal,
  DeleteTaxRegionWithoutDomainEventsRequest as DeleteTaxRegionWithoutDomainEventsRequestOriginal,
  DeleteTaxRegionWithoutDomainEventsResponse as DeleteTaxRegionWithoutDomainEventsResponseOriginal,
  BulkRestoreTaxRegionsRequest as BulkRestoreTaxRegionsRequestOriginal,
  BulkRestoreTaxRegionsResponse as BulkRestoreTaxRegionsResponseOriginal,
  BulkRestoreTaxRegionsResult as BulkRestoreTaxRegionsResultOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountDetails as AccountDetailsOriginal,
  CreateTaxRegionApplicationErrors as CreateTaxRegionApplicationErrorsOriginal,
  UpdateTaxRegionApplicationErrors as UpdateTaxRegionApplicationErrorsOriginal,
} from './billing-v1-tax-region-tax-regions.types.js';
